import { Box } from '@mui/material'
import { DetailsTable } from 'Features/Projects/Scenarios/Templates/TemplateResults/Details/Details.table'
import { TemplateOutputs } from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.types'

type DetailsViewProps = {
  data: TemplateOutputs[]
  isLoading: boolean
}

/** The template's rows, week by week. The grid takes the column's width. */
export const DetailsView = ({ data, isLoading }: DetailsViewProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
    <DetailsTable data={data} isLoading={isLoading} />
  </Box>
)
